import { useAuthStore } from "@/pinia/authStore";
// --- helpers สำหรับ Base64URL (unicode-safe) ---
function b64uDecode(s) {
  let b64 = String(s).replace(/-/g, '+').replace(/_/g, '/');
  while (b64.length % 4) b64 += '=';
  return decodeURIComponent(escape(atob(b64)));
}
function isB64u(s) {
  if (typeof s !== 'string') return false;
  if (!/^[A-Za-z0-9\-_]+$/.test(s)) return false;
  try {
    // ลองถอด ถ้าถอดได้ถือว่าเป็น base64url
    b64uDecode(s);
    return true;
  } catch {
    return false;
  }
}
// ระบุคีย์พารามิเตอร์ที่ต้อง "แสดงผลแบบถอดรหัส"
const DECODE_KEYS = ['phone', 'shelterId', 'victimId', 'populationId','officerId','pendingApprovalListId','publicRelationsId','caregiverId']
// ถอดรหัสเฉพาะคีย์ที่กำหนด (รองรับ array ด้วย)
function getDecodedParams(params = {}) {
  const out = { ...params };
  for (const k of DECODE_KEYS) {
    const v = out[k];
    if (v == null) continue;
    if (Array.isArray(v)) {
      out[k] = v.map(item => (isB64u(item) ? b64uDecode(item) : item));
    } else {
      out[k] = isB64u(v) ? b64uDecode(v) : v;
    }
  }
  return out;
}

// export function getResolvedBreadcrumbs(route, router) {
//   // ซ่อนเฉพาะใน label (ลิงก์ยังใช้ค่า param จริง)
//   const HIDE_PARAMS = ['populationFormId', 'assessmentFormId'];

//   // map ชื่อ -> route record
//   const byName = new Map(router.getRoutes().map(r => [r.name, r]));

//   // ส่งเฉพาะ params ที่ route นั้นประกาศไว้จริง ๆ เพื่อลด warning
//   const pickRouteParams = (rec, params = {}) => {
//     const keys = Array.from(rec.path.matchAll(/:([^/]+)/g)).map(m => m[1]);
//     const out = {};
//     for (const k of keys) if (params[k] != null) out[k] = params[k];
//     return out;
//   };

//   let curName = route.name;
//   const breadcrumbs = [];

//   while (curName) {
//     const rec = byName.get(curName);
//     if (!rec) break;

//     // สร้าง "route สำหรับแสดงผล" ที่ params ถูก decode เฉพาะคีย์ที่กำหนด
//     const viewRoute = {
//       ...route,
//       params: getDecodedParams(route.params),
//     };

//     // ใช้เฉพาะ meta.breadcrumb เท่านั้น
//     let raw = typeof rec.meta?.breadcrumb === 'function'
//       ? rec.meta.breadcrumb(viewRoute)    // << ใช้ viewRoute (decoded)
//       : rec.meta?.breadcrumb;

//     if (raw) {
//       // ซ่อนค่าพารามิเตอร์บางตัวใน label (อ้างอิงค่าที่ decode แล้ว)
//       let label = String(raw);
//       for (const k of HIDE_PARAMS) {
//         const v = viewRoute.params?.[k];
//         if (v != null) label = label.replaceAll(String(v), '');
//       }
//       label = label.replace(/\s{2,}/g, ' ').trim();

//       // ลิงก์ใช้ params/query จริง (ที่ encode แล้ว)
//       const href = router.resolve({
//         name: rec.name,
//         params: pickRouteParams(rec, route.params),
//         query: route.query,
//       }).href;

//       breadcrumbs.unshift({ label, path: href });
//     }

//     // เดินขึ้น parent ตาม meta.parent (เป็นชื่อ route)
//     curName = rec.meta?.parent || null;
//   }

//   return breadcrumbs;
// }



export function getResolvedBreadcrumbs(route, router) {
  // คีย์พารามิเตอร์ที่ต้องซ่อนเฉพาะใน label
  const HIDE_PARAMS = ['populationFormId', 'assessmentFormId'];

  // อ่าน role แบบปลอดภัย (ถ้าหา store ไม่เจอ จะถือว่าไม่ใช่ staff)
  let role = '';
  try {
    // ถ้ามี useAuthStore ให้ใช้ได้เลย
    const auth = (typeof useAuthStore === 'function') ? useAuthStore() : null;
    role = String(auth?.userData?.role || '').toLowerCase();
  } catch (_) {}
  const isStaff = role === 'staff';

  // สร้าง map ชื่อ -> route record
  const byName = new Map(router.getRoutes().map(r => [r.name, r]));

  // ส่งเฉพาะ params ที่ route นั้นประกาศไว้จริง ๆ เพื่อลด warning
  const pickRouteParams = (rec, params = {}) => {
    const keys = Array.from(rec.path.matchAll(/:([^/]+)/g)).map(m => m[1]);
    const out = {};
    for (const k of keys) if (params[k] != null) out[k] = params[k];
    return out;
  };

  let curName = route.name;
  const crumbs = [];

  // เป็นหน้าใด ๆ ใต้ /shelter/:shelterId ... ?
  const underShelterDetails = String(route.path || '').startsWith('/shelter/') && route.name !== 'shelter';

  while (curName) {
    const rec = byName.get(curName);
    if (!rec) break;

    // ถ้าเป็น staff และอยู่ใต้ /shelter/:shelterId... ให้ "ข้าม" crumb 'shelter'
    if (isStaff && underShelterDetails && rec.name === 'shelter') {
      curName = rec.meta?.parent || null; // ข้ามไปหา parent ถัดไป
      continue;
    }

    // สำหรับ label ให้ใช้ params แบบ decoded เฉพาะคีย์ที่กำหนด
    const viewRoute = { ...route, params: getDecodedParams(route.params) };

    // meta.breadcrumb รองรับทั้ง string และ function(route)
    let raw = typeof rec.meta?.breadcrumb === 'function'
      ? rec.meta.breadcrumb(viewRoute)
      : rec.meta?.breadcrumb;

    if (raw) {
      // ซ่อนค่าพารามิเตอร์บางตัวเฉพาะใน label
      let label = String(raw);
      for (const k of HIDE_PARAMS) {
        const v = viewRoute.params?.[k];
        if (v != null) label = label.replaceAll(String(v), '');
      }
      label = label.replace(/\s{2,}/g, ' ').trim();

      // ลิงก์ใช้ params/query จริง (encode เดิม)
      const href = router.resolve({
        name: rec.name,
        params: pickRouteParams(rec, route.params),
        query: route.query,
      }).href;

      crumbs.unshift({ label, path: href });
    }

    // เดินขึ้น parent
    curName = rec.meta?.parent || null;
  }

  return crumbs;
}